import type { SearchContext } from '@shared/types/types.ts';
import { FASHION_ASSORTMENTS_SET } from '@tilelist/domain/feature-visibility/FashionAssortments.ts';

/**
 *
 *
 *
 */

function normalizeAssortment(searchContext: SearchContext | undefined): string | undefined {
    const assortment = searchContext?.assortment;
    return assortment ? assortment.toLowerCase() : undefined;
}

export function shouldShowRating(searchContext?: SearchContext): boolean {
    const normalized = normalizeAssortment(searchContext);
    if (!normalized) return true;

    return !FASHION_ASSORTMENTS_SET.has(normalized);
}
